import { render } from "./LinkRichText.vue?vue&type=template&id=5e7ec2c9"
import script from "./LinkRichText.vue?vue&type=script&lang=js"
export * from "./LinkRichText.vue?vue&type=script&lang=js"

import "./LinkRichText.vue?vue&type=style&index=0&id=5e7ec2c9&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__